import { DeleteUploadReadFileExpenseType } from "../../../domain/useages/expense-dashboard/delete-upload-read-file-expense";
import { HttpConstants } from "../../protocols/http/http-constants";
import { HttpPutClient } from "../../protocols/http/http-put-client";


export class RemoteDeleteUploadReadFileExpense implements DeleteUploadReadFileExpenseType {
  constructor(
    private readonly url: string,
    private readonly httpPutClient: HttpPutClient
  ) {}

  async update(payload: DeleteUploadReadFileExpenseType.Params): Promise<any> {
    const httpResponse = await this.httpPutClient.put({
      url: this.url,
      body: payload,
      headers: {
        [HttpConstants.CONTENT_TYPE]: HttpConstants.APPLICATION_JSON,
        [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
         [HttpConstants.APP_ID]: HttpConstants.APP_ID_VALUE,
      },
      authHeaders: true,
    });
      return httpResponse.data;
  }
}
